const capitalizeFirstLetter = (str: string): string => {
    return str.charAt(0).toUpperCase() + str.slice(1)
}

const extractInitials = (str: string): string => {
    return str.split(' ')
        .map(word => word.substring(0, 1).toUpperCase()).join('');
}

export {capitalizeFirstLetter, extractInitials}
